// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"196":"0f6628a3f5b314e8118c","241":"4acde6c0c0d32cbea5e4","502":"e496ba4f2d682e522276","507":"67c1f4b5fdc9b5265d02","873":"d2ae99055678ca5747df"}[chunkId] + ".js";
};